import React from "react"
import "../assets/css/main.css"

export default function Main() {
  return (
    <div className="main">
      {/* <div className="main-text-container">
        <h1 className="main-heading">
          Green Hydrogen for Global Decarbonization
        </h1>
        <p className="main-desc">
          Green Hydrogen is expected to become a $ 12-15 trillion global
          industry by 2050. Green Hydrogen has the potential to become a vital
          component of the energy mix in the next few decades that has captured
          a clear investor interest.
          <br />
          The first International Hydrogen Energy & Economy conference which is
          being organised by the Catalysis & Hydrogen Research lab from school
          of petroleum technology in Pandit Deendayal Energy University,
          Gandhinagar, Gujarat.
        </p>
      </div>
      <div className="heading-container"> */}
      {/* <div className="card">Thrust Areas</div>
        <div className="card">Objectives & Outcomes</div>
        <div className="card">Organizing Committee</div>
        <div className="card">Fees & Important Dates</div>
        <div className="card">About Us</div> */}
      {/* <p>Green Hydrogen</p>
      </div> */}
      <div className="HeroSection">
        <p className="MainHeading1">
          1<sup className="heading-smallcase">st </sup> International Conference
          on
          <br />
          GREEN HYDROGEN FOR GLOBAL DECARBONIZATION
          {/* </p> */}
          {/* <p className="MainHeading2"> */}
        </p>
        <p className="SecondSmallText">
          March 17  - 18 <sup>th </sup>, 2023
        </p>
        <p className="ThirdSmallText">
          Pandit Deendayal Energy University
          <br />
          Gandhinagar, 
          Gujarat, <br /> India
        </p>
      </div>
    </div>
  )
}
